<script lang="ts" setup>
import LightArrowIcon from "@/components/icon/LightArrowIcon.vue";
import { useRouter } from "vue-router";
import { computed, onBeforeMount, ref, UnwrapRef } from "vue";
import { useMoment } from "@/stores/moment";

import { Moment } from "@/types/entity";
import ThreadItem from "@/components/mobile/ThreadItem.vue";
import { useGlobalUser } from "@/stores/globalUser";
import MomentActions from "@/components/mobile/popup/MomentActions.vue";
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";

const router = useRouter();
const moment = useMoment();
const loading = ref(false);
const momentList = ref<Moment[]>([]);
const globalUser = useGlobalUser();
const sort = ref<"asc" | "desc">("asc");
const sortedMomentList = computed(() => {
  return [...momentList.value].sort((a, b) => {
    if (sort.value === "asc") {
      return new Date(a.dtCreate).getTime() - new Date(b.dtCreate).getTime();
    } else {
      return new Date(b.dtCreate).getTime() - new Date(a.dtCreate).getTime();
    }
  });
});

onBeforeMount(async () => {
  loading.value = true;
  try {
    const { rootId, mateId } = router.currentRoute.value.query;
    if (!rootId || !mateId) {
      router.back();
    }
    momentList.value = await moment.fetchMomentByRootId(
      Number(mateId),
      Number(rootId)
    );
  } finally {
    loading.value = false;
  }
});

const showActions = ref(false);
const toOperateMoment = ref<Moment | null>(null);
const onActionClick = (moment: UnwrapRef<Moment>) => {
  toOperateMoment.value = moment;
  showActions.value = true;
};
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr]">
    <threads-nav show-back>
      <template #center>
        <div>{{ $t("Community.moment") }}</div>
      </template>
    </threads-nav>
    <div class="overflow-y-auto">
      <div
        v-if="loading"
        class="w-full h-full flex items-center justify-center"
      >
        <span class="loading"></span>
      </div>
      <div v-else class="p-4">
        <thread-item
          v-for="item in sortedMomentList"
          :key="item.uuid"
          :avatar-url="item.mate.mediaUrl"
          :chat-message-list="item.chatMessagezz"
          :content="item.text"
          :enable-reaction-btn="globalUser.isLogin"
          :from-mate="item.fromMate"
          :has-next="item.childId != null"
          :has-prev="item.parentId != null"
          :impression-reactions="[]"
          :mate-id="item.mate.uuid"
          :mate-tone-id="item.mate.mateToneId"
          :media-list="item.mediazz"
          :mention-matezz="item.mentionMatezz"
          :moment="item"
          :reply="item.reply"
          :time="item.dtCreate"
          :title="item.mate.name"
          :type="item.mate.type"
          :uuid="item.uuid"
          :gal-game="item.galGame"
          :visibility="item.visibility"
          class="border-b-0"
          enable-audio-play
          @reaction-click="onActionClick(item)"
          @thread-click="
            router.push({
              name: 'threadDetail',
              params: { uuid: item.uuid },
            })
          "
        />
      </div>
      <moment-actions v-model:show="showActions" :moment="toOperateMoment" />
    </div>
  </div>
</template>
